import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { getMeeting } from '../../../../Requests/MeetingRequests';
import ExpandedMeetingCard from '../../../../Components/Meetings/ExpandedMeetingCard';
import { AreaChart, Card, Title } from "@tremor/react";
import ExpandedAnalysisCard from '../../../../Components/Analysis/ExpandedAnalysisCard';
import { useSidebar } from '../../../../Components/ContextProviders/SidebarContextProvider';
import { getSidebarPadding } from '../../../../utils/sidebar';


function Analys() {
    const { isCollapsed } = useSidebar();
    
    return (
        <div className={`${getSidebarPadding(isCollapsed)} transition-all duration-300 py-12 w-full flex justify-center h-full px-4`}>
            <div className='flex flex-col w-full justify-center items-center h-full'>
                <div className='bg-white max-w-7xl rounded-2xl w-full h-full shadow-xl mx-8  '>
                    <ExpandedAnalysisCard />
                </div>
            </div>

        </div>
    )
}

export default Analys
